import React from 'react';
import { MenuItem, TextField } from '@mui/material';

const levels = ['', 'INFO', 'WARN', 'ERROR', 'DEBUG'];

const LevelSelect: React.FC<{ value: string; onChange: (v: string)=>void }> = ({ value, onChange }) => (
  <TextField select label="Level" size="small" value={value} onChange={e=>onChange(e.target.value)} style={{width:120}}>
    {levels.map(l=>(<MenuItem key={l} value={l}>{l||'ALL'}</MenuItem>))}
  </TextField>
);

export default LevelSelect; 